// src/components/common/Notification.jsx
import React, { useEffect } from 'react';
import './Toast.css';

const Toast = ({ 
    show, 
    type = 'info', 
    message, 
    onClose, 
    autoHideDuration = 5000 
}) => {
    useEffect(() => {
        if (!show || !autoHideDuration) return;
        
        const timer = setTimeout(() => {
            onClose?.();
        }, autoHideDuration);
        
        return () => clearTimeout(timer);
    }, [show, autoHideDuration, onClose]);

    if (!show) return null;

    const icon = 
        type === 'error' ? 'bi-exclamation-triangle-fill' :
        type === 'warning' ? 'bi-exclamation-triangle-fill' :
        type === 'success' ? 'bi-check-circle-fill' :
        'bi-info-circle-fill';

    return (
        <div className={`notification notification-${type}`}>
            <div className="notification-content">
                <i className={icon}></i>
                <span>{message}</span>
            </div>
            <button className="notification-close" onClick={onClose}>
                <i className="bi bi-x"></i>
            </button>
        </div>
    );
};

export default Toast;